import 'css-chunk:src/app/containers/Home/ClientsView/ClientDetailView.scss';export default {
  "ClientDetailView": "_ClientDetailView_j1bkz_2",
  "header": "_header_j1bkz_2",
  "action": "_action_j1bkz_7",
  "children": "_children_j1bkz_10",
  "menu": "_menu_j1bkz_10",
  "warning": "_warning_j1bkz_14",
  "warning_light": "_warning_light_j1bkz_18"
};